import { isRequired } from '../../utils.js';

var timeSpent = (_ref => {
  let {
    /**
     * `total_duration` is the time in milliseconds the time spent on the page.
     * `active_duration` is the time in milliseconds the time spent on the page where
     * the user was active
     */
    total_duration = isRequired('total_duration'),
    active_duration = isRequired('active_duration')
  } = _ref;
  return () => ({
    total_duration,
    active_duration
  });
});

export default timeSpent;
